
export const TEDDYS_SUBCATEGORIES = [
  "Bears",
  "Foxes",
  "Bunniesrabbits",
  "Monkeys",
  "Cats and felines",
  "Birds",
  "Elephants",
  "Dogswolves",
  "Pigsungulates",
  "Rodents",
  "Mustelids",
  "Hedgehogs",
  "Raccoons",
  "Fantasycreatures"
];